<template>
  <div class="card card-scrapbook tw-h-full tw-flex tw-flex-col">
    <div @click="viewPost" v-if="hasImage" class="card-image tw-cursor-pointer">
      <figure class="image is-4by3">
        <img v-lazy="post.image.url" alt="Post image" />
      </figure>
    </div>
    <div @click="viewPost" class="card-content tw-cursor-pointer">
      <div class="content quill" :class="{ 'tw-mt-5': !hasImage }">
        <span
          v-if="hasImage"
          class="tag has-text-weight-bold tw-text-white"
          :class="postTypeColor"
        >
          {{ post.postTypeString }}
        </span>
        <div class="is-size-6" v-if="full" v-html="post.post"></div>
        <div
          class="is-size-6 post-truncated"
          :class="{ 'has-image': hasImage }"
          v-else
        >
          {{ strippedPost }}
        </div>
        <span
          v-if="!hasImage"
          class="tag has-text-weight-bold tw-text-white"
          :class="postTypeColor"
        >
          {{ post.postTypeString }}
        </span>
      </div>
    </div>
    <div class="media tw-p-6 tw-pt-0 tw-mt-auto">
      <div class="media-left">
        <figure class="image is-32x32">
          <img
            class="is-elongated"
            v-lazy="post.user.avatar_url + '?ts=' + auth.timestamp"
            alt="User image"
          />
        </figure>
      </div>
      <div class="media-content">
        <p class="title is-6">Posted by {{ post.user.full_name }}</p>
        <p class="subtitle is-6 tw-text-grey-lighter">
          <small>{{ post.createdAtFromNow }}</small>
        </p>
      </div>
      <div class="media-right" v-if="full && post.user.id !== auth.user.id">
        <b-dropdown position="is-top-left" aria-role="list">
          <button slot="trigger" class="button is-white tw-min-w-0">
            <b-icon icon="dots-horizontal"></b-icon>
          </button>

          <b-dropdown-item @click="reportPost" aria-role="listitem">
            Report post
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Post from '@/models/Post'
import * as PostType from '@/utils/consts/PostType'
export default {
  props: {
    post: {
      type: Post
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    hasImage() {
      return !!this.post.image
    },
    strippedPost() {
      const el = document.createElement('div')
      el.innerHTML = this.post.post
      return el.textContent || el.innerText || ''
    },
    postTypeColor() {
      if (this.post.post_type === PostType.PRAYER) {
        return 'tw-bg-post-prayer'
      } else if (this.post.post_type === PostType.IDEA) {
        return 'tw-bg-post-idea'
      } else {
        return 'tw-bg-post-story'
      }
    }
  },
  methods: {
    reportPost() {
      this.$emit('report', this.post)
    },
    viewPost() {
      this.$router.push({
        name: 'student-hub.view',
        params: { id: this.post.id }
      })
    }
  }
}
</script>
